import { IEnvironment } from './models';

export const environment: IEnvironment = {
    environment: 'local',
    notFoundUrl: '/not-found',
    serverApiUrl: '/xm-api',
    version: 'x.x.x',
    release: 'x.x.x',
    production: false,
};
